import React from "react"
import { ReactNode } from "react"
import styled from "styled-components"

type Props = {
  className?: string
  children?: ReactNode
}

const Component: React.VFC<Props> = (props) => {
  return <h3 className={`${props.className} input-title`}>{props.children}</h3>
}

const StyledComponent = styled(Component)`
  padding: 6px 16px;
  background: #e2e7ec;
  font-weight: bold;
  font-size: 1.3rem;
`

export const InputTitle = StyledComponent
